var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"indexBox waitingSeason",staticStyle:{"margin-top":"80px"}},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/img/fanzone/md_point_2025.jpg"),"alt":"md_point_info"}})])])])
}]

export { render, staticRenderFns }